import { useContractPlanDetail } from './hooks';
import { convertToPresentationProps } from './logics';
import { ContractPlanDetailPresentation } from './presentations';

type Props = {
  /** 契約プラン ID */
  planId: number;
};

/**
 * 契約プラン詳細 Container
 *
 * 親コンポーネント（Screen）で Suspense にラップすること
 */
export const ContractPlanDetail: React.FC<Props> = ({ planId }) => {
  const {
    state: { data },
  } = useContractPlanDetail(planId);

  const {
    title,
    kindBadge,
    giftPlan,
    customerChargeUnitPrice,
    taxRatePercent,
    createdAt,
    updatedAt,
  } = convertToPresentationProps({ data: data.contract_plan });

  return (
    <ContractPlanDetailPresentation
      title={title}
      kindBadge={kindBadge}
      giftPlan={giftPlan}
      customerChargeUnitPrice={customerChargeUnitPrice}
      taxRatePercent={taxRatePercent}
      createdAt={createdAt}
      updatedAt={updatedAt}
    />
  );
};
